import { useMemo, useState } from 'react';
import ReportWrapper from '../components/reportArea/ReportWrapper';
import FilterDiv from 'lib/filters-lib/FilterDiv';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';
import { defaultReportTimeFrame, defaultReportType } from '../data/defaultSchema';
import { updateReportPlotArea } from '../utils/dragableFunctions';
import { mls } from 'lib/multilanguagesupport';
interface mainPorps {
  toggleProps: {
    minimizedDiv: string[];
  };
  mainPorps: any;
}
const ReportArea = (props: mainPorps) => {
  const { toggleProps, mainPorps } = props;

  const { minimizedDiv } = toggleProps;
  const {
    reports,
    reportFilter,
    setReportFilter,
    appID,
    reportTimeFrame,
    setReportTimeFrame,
    tableDataInSheetID,
    setReports,
    handleTableData,
    analyticsSchema,
    chartsData,
    setTableDataInSheetID,
    setReportAreaLoading,
  } = mainPorps.stateProps;
  const presentActiveColumn = useMemo(() => {
    let filtered = minimizedDiv.filter(Boolean);
    if (filtered?.length === 0) {
      return 'twoColumnOpen';
    }
    if (filtered?.length === 1) {
      return 'oneColumnOpen';
    }
    return '';
  }, [minimizedDiv]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [initialReportFilter, setInitialReportFilter]: any[] = useState(
    JSON.stringify(reportFilter ?? {})
  );

  const handleReportFilter = async (action: boolean) => {
    const filterInString = JSON.stringify(reportFilter ?? {});
    if (action) {
      setInitialReportFilter(filterInString);
      setIsFilterVisible(action);
      return;
    }
    if (filterInString !== initialReportFilter) {
      setReportAreaLoading(true);
      const updateReportPlotAreaProps = {
        reports,
        analyticsSchema,
        chartsData,
        setTableDataInSheetID,
        tableDataInSheetID,
        handleTableData,
        reportTimeFrame,
        reportFilter,
        appID,
      };
      setIsFilterVisible(action);
      const reportsData = await updateReportPlotArea(updateReportPlotAreaProps);
      if (!reportsData.skip) {
        setReports(reportsData.reports);
      }
      setReportAreaLoading(false);
    } else {
      setIsFilterVisible(action);
    }
  };

  const handleTimeFrame = async (action: any) => {
    setReportAreaLoading(true);

    const timeFrameObject = {
      period: action,
    };
    const finalTimeFrame = action === 'null' ? {} : timeFrameObject;

    setReportTimeFrame(finalTimeFrame);
    const updateReportPlotAreaProps = {
      reports,
      analyticsSchema,
      chartsData,
      setTableDataInSheetID,
      tableDataInSheetID,
      handleTableData,
      reportTimeFrame: finalTimeFrame,
      reportFilter,
      appID,
    };
    const reportsData = await updateReportPlotArea(updateReportPlotAreaProps);
    if (!reportsData.skip) {
      setReports(reportsData.reports);
    }
    setReportAreaLoading(false);
  };

  return (
    <div className={`thirdColumn ${presentActiveColumn}`}>
      <>
        {isFilterVisible ? (
          <>
            <FilterDiv
              isPopUp={isFilterVisible}
              setIsPopUp={handleReportFilter}
              isJoinedTable={true}
              allTableData={tableDataInSheetID}
              setChartFilter={setReportFilter}
              chartFilter={reportFilter}
              appID={appID}
              sheetID={''}
              isDashboard={true}
            />
          </>
        ) : null}

        <div className='selectTimeFrameDiv'>
          <div className='titleDiv'>
            {mls('TimeFrame')}
            <span>:</span>
          </div>
          <div className='selectTimeFrameDivDropDown'>
            <ObjectDropDown
              object={defaultReportTimeFrame}
              dropDownValue={reportTimeFrame.period}
              setdropDownValue={handleTimeFrame}
              // ObjectInObject={true}
            />
          </div>
        </div>
        <ReportWrapper
          stateProps={mainPorps.stateProps}
          setIsFilterVisible={setIsFilterVisible}
          handleReportFilter={handleReportFilter}
        />
      </>
    </div>
  );
};

export default ReportArea;
